import { when } from 'mobx'
import { Document } from 'mobx-document'
import { bewizrAPI } from '~/apis/bewizr'
import { BeWizrEmbedItem, BeWizrLibraryItemType, BeWizrLinkItem, BeWizrMediaItem } from '~/models'
import bewizrStore from '../bewizrStore'

export default class BeWizrMiscItemDocument extends Document<BeWizrEmbedItem | BeWizrMediaItem | BeWizrLinkItem> {

  public type: 'embed' | 'media' | 'link' | null = null

  protected async performFetch() {
    if (this.type == null) {
      console.error('Fetching a BeWizr misc item requires an item type to be set')
      return null
    }

    await when(() => bewizrStore.authenticated)

    const api = bewizrAPI()
    if (api == null) { return null }

    const response = await api.get(`misc_item/${this.type}/${this.id}/`)
    if (response.status !== 200) { return response }

    const raw = response.data
    const Model = BeWizrLibraryItemType.ModelForType(raw.type)
    if (Model == null) {
      console.error(`Unknown item type: ${raw.type}`)
      return null
    }
    const item = (Model as any).deserialize(raw)
    return {
      data: item as BeWizrEmbedItem | BeWizrMediaItem | BeWizrLinkItem,
      meta: {},
    }
  }
}